const styles = {
  container: {
    position: 'absolute',
    top: '5vh',
    paddingLeft: '3em',
    height: '85vh',
    paddingBottom: '2em',
    overflowX: 'auto',
  },
};

export default styles;
